import React, { useContext } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import logo from "./../../assets/agencyIQ_Logo.png";
import { UserContext } from "../UserContext";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingLeft: theme.spacing(6),
  },
  ctaButton: {
    padding: 12,
    background: "#041E42",
    color: "white",
    borderRadius: 4,
    "&:hover": {
      background: "#28367B",
      color: "white",
    },
    marginTop: theme.spacing(4),
  },
  heading: {
    fontSize: 34,
    fontWeight: "bold",
    color: "#28367B",
    marginBottom: 10,
  },
  container: {
    marginTop: 20,
    width: 750,
    height: 410,
    background: "white",
    display: "flex",
    margin: "auto",
    borderRadius: 10,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  card: {
    marginTop: 10,
    width: "100%",
    height: "auto",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  logo: {
    height: 80,
  },
  content: {
    margin: 10,
    textAlign: "center",
  },
  subHeading: {
    margin: 10,
    fontSize: 18,
    textAlign: "center",
    lineHeight: 2,
  },
}));

const ENROLLMENT_REDIRECT_URL = process.env.REACT_APP_SIAA_LEARN_MORE_URL;

export function UnavailableFeatureForNonDSACEO(props) {
  const classes = useStyles();
  const { user } = useContext(UserContext);
  const isAMSSupportPending = user.isAMSSupportPending();

  const handleRedirect = () => {
    window.open(ENROLLMENT_REDIRECT_URL, "_blank");
  };

  return (
    <Container className={classes.container}>
      <div className={classes.card}>
        <div className={classes.logoContainer}>
          <img className={classes.logo} src={logo} alt="AgencyIQ" />
        </div>

        <div className={classes.content}>
          <Typography
            variant="h4"
            className={classes.heading}
            style={{ fontWeight: 900 }}
          >
          {isAMSSupportPending ? 
              "This feature is unavailable for your AMS!"
              : "Sorry, You Have Limited Access"}
            
          </Typography>

          <div className={classes.subHeading}>
            <Typography variant="h6">
              {isAMSSupportPending ? <>
              This feature requires integration with your AMS, which we don’t support just yet. The good news? We’re actively working to expand our AMS integrations — including yours.<br/>
              Stay tuned, and we’ll notify you as soon as it’s ready!
              </>
              : "This feature is not available with your current access level."}
            </Typography>
          </div>

          {!isAMSSupportPending && (<Button
            classes={{
              root: classes.ctaButton,
            }}
            onClick={handleRedirect}
          >
            Learn More
          </Button>)}
        </div>
      </div>
    </Container>
  );
}

UnavailableFeatureForNonDSACEO.propTypes = {
  isBillingAllowed: PropTypes.bool.isRequired,
  feature: PropTypes.string,
};
